<template>
  <div id="index">
    <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
      <el-main>
        <nav-bar></nav-bar>
        <el-form
          ref="formselect"
          :model="formselect"
          label-width="100px"
          class="queryform_div"
        >
          <el-row :gutter="24">
            <el-col :md="8" :sm="12" :xs="24">
              <el-form-item :label="$t('RunningTIme.FileName')">
                <el-input
                  style="width: 100%"
                  v-model="formselect.queryString"
                  size="small"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :md="8" :sm="24" :xs="24" style="margin-top: 10px">
              <el-button type="primary" @click="getDatas('search')" size="small">
                {{$t("button.query")}}
              </el-button>
              <el-button @click="formselect.queryString = ''" size="small">{{
                $t("button.reset")
              }}</el-button>
            </el-col>
          </el-row>
        </el-form>
        <template>
          <div class="tableDiv">
            <el-table
              :data="tableData1"
              stripe
              style="width: 100%"
              :empty-text="$t('desc.noData')"
            >
              <el-table-column
                type="index"
                :label="$t('title.serialNumber')"
                width="60px"
                fixed="left"
              >
              </el-table-column>
              <el-table-column
                prop="name"
                :label="$t('RunningTIme.Name')"
                min-width="120px"
              >
              </el-table-column>
              <el-table-column
                prop="fileType"
                :label="$t('RunningTIme.Type')"
                min-width="50px"
              >
              </el-table-column>
              <el-table-column
                prop="lastModified"
                :label="$t('RunningTIme.LastModify')"
                min-width="100px"
              >
              </el-table-column>
              <el-table-column
                prop="size"
                :label="$t('RunningTIme.Size')"
                min-width="40px"
              >
              </el-table-column>
              <el-table-column
                prop="storageClass"
                :label="$t('RunningTIme.StorageClass')"
                min-width="80px"
              >
              </el-table-column>
              <el-table-column 
              :label="$t('title.operate')"
              width="90px">
                <template slot-scope="scope">
                  <el-button
                    type="default"
                    icon="el-icon-download"
                    circle
                    size="mini"
                    :title="$t('RunningTIme.Download')"
                    v-show="hasDownLoadAuth"
                    @click="downLoadRunTImeFileFromS3(scope.row)"
                  >
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              layout="prev, pager, next,sizes"
              :total="pagination.totalPage"
              :current-page.sync="pagination.current"
              :page-size="pagination.pageSize"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              style="text-align: center; margin-top: 10px"
            ></el-pagination>
          </div>
        </template>
      </el-main>
    </el-scrollbar>

  </div>
</template>

<script>
import {
  authOperationCheck,
  getRunningTimeList,
  downLoadRunTImeFileFromS3,
  getS3FileList,
  downLoadFoldFileFromS3
} from "../../api/api";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "Index",

  mounted() {
    this.getDatas();
  },

  data() {
    return {
      hasDownLoadAuth: false,
      tableData1: [],
      formselect: {},
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
    };
  },
  created: function () {
    this.authOperation("RunningTime");
  },
  methods: {
    async authOperation(curPage) {
      var that = this;
      var res = await authOperationCheck(curPage);
      that.hasDownLoadAuth = res.hasDownLoadAuth;
    },
    async getDatas(type = "normal"){
      let that = this;
      if (type == "search") {
        this.pagination.current = 1;
      }
      let skipcount = (this.pagination.current - 1) * this.pagination.pageSize;
      // let postData = {
      //   FileName: this.formselect.queryString,
      //   SkipCount: skipcount,
      //   MaxResultCount: this.pagination.pageSize,
      // };
      // let res = await getRunningTimeList(postData);
      let postData = {
        FileName: that.formselect.queryString,
        FoldName: "report1",
        SkipCount: skipcount,
        MaxResultCount: that.pagination.pageSize,
      };
      let res = await getS3FileList(postData);
      let data = res.result.items;
      that.pagination.totalPage = res.result.totalCount;
      that.tableData1 = data;
    },
    async downLoadRunTImeFileFromS3(row){
      let that=this;
      let res = await downLoadFoldFileFromS3(row.keyName);
      // const blob = new Blob([res]);//处理文档流
      const fileName = row.keyName;
      const elink = document.createElement('a');
      elink.download = fileName;
      elink.style.display = 'none';
      elink.href = res.result;
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getDatas();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getDatas();
    },
  },

  computed: mapState({
    isCollapse: (state) => state.isCollapse,
  }),
};
</script>

<style scoped>
#formPer .el-form-item__content {
  line-height: 35px;
  border-left: 1px solid #828393;
  padding-left: 10px;
}

#formPer > div {
  margin-bottom: 0px;
  border-bottom: 1px solid #828393;
}

#formPer .noborder .el-form-item__content {
  border: 0;
}

#formPer .noborder {
  border: 0;
  margin-top: 20px;
}
#formPer .el-form-item {
  margin-bottom: 5px;
  margin-top: 5px;
}
#formPer .el-checkbox-group {
  line-height: 16px;
  margin-top: 6px;
}
#formPer .el-checkbox {
  min-width: 80px;
}
</style>
